module.exports = __webpack_public_path__ + "static/img/img.57fb36e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img.png
// module id = b4/+
// module chunks = 1